export default __webpack_public_path__ + "static/media/upload-icon.504434e2.svg";